<template>
  <div>
    <el-menu class="navbar" mode="horizontal" style="overflow:hidden;">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <levelbar></levelbar>
      <!-- <tabs-view></tabs-view> -->
      <screenfull class='screenfull'></screenfull>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="photoUrl">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <el-dropdown-item divided v-if="myname" style="border-top:0px;margin-top:0px;">
            <span style="display:block;">{{myname}}</span>
          </el-dropdown-item>
          <el-dropdown-item divided v-if="showDiv">
            <span @click="changePSW" style="display:block;">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="runLogout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!--修改密码-->
      <div class="pass">
        <el-dialog title="修改密码" v-model="showDialog" style="width:100%">
          <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
            <el-form-item label="密码" prop="pass">
              <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm2')">提交</el-button>
              <el-button @click="resetForm('ruleForm2')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </el-menu>
    <div class="headercontent" v-show="baseInfo">
      <div class="one_div" style="display: inline-block">门店：{{navbarData.agent_name}}</div>
      <div class="two_div" style="display: inline-block;margin-left: 15px">合作商：{{navbarData.qnbar_agent_name}}</div>
      <div class="three_div" style="display: inline-block;margin-left: 15px">技术服务电话:{{navbarData.qnbar_agent_tel}}</div>
      <div class="one_div" style="display: inline-block;margin-left: 15px">{{ complaintCall }}</div>
      <div class="four_div" style="display: inline-block;margin-left: 15px">已使用:{{navbarData.useDay}}天</div>
      <div class="five_div" style="display: inline-block;margin-left: 15px">还剩余:{{navbarData.distime | lastDayFilter(navbarData.lastDay)}}天</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"; //获取vuex数据
import Levelbar from "./Levelbar"; //面包屑导航
import Hamburger from "@/components/Hamburger"; //隐藏侧边栏
import TabsView from "./TabsView"; //历史打开页面保存
import Screenfull from "@/components/Screenfull"; //全屏
import { agencyQnbarRequest } from '@/utils'
// 请求参数设置
import base from "@/base.js";
import EnvBase from "@/env.js";
import SvrApi from "@/svrapi.js";
var PT = EnvBase.PT;

export default {
  components: {
    Levelbar,
    Hamburger,
    Screenfull,
    TabsView
  },
  data: function() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      user_title: "",
      myname: "",
      photoUrl:
        "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80",
      showDialog: false,
      ruleForm2: {
        pass: "",
        checkPass: ""
      },
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      showDiv: false,
      lastD: "",
      baseInfo:false,
      complaintCall: '',    //投诉电话
    };
  },
  mounted: function() {
    var self = this;
    PT.apiClient.query("bz-mix/bz/get-base-info", "", function(rsp) {
      if (rsp.code == 0) {
        localStorage.setItem("user_data", JSON.stringify(rsp.data));
        var userInfo = JSON.parse(self.commonGetLocalDataNew("user_data"));
        var identity = JSON.parse(self.commonGetLocalDataNew("identity"));
        var user_all = JSON.parse(localStorage.getItem("user_all"));
        // console.log(userInfo)
        self.userInfo = userInfo;
        self.identity = identity;
        if (
          identity.user_type == "merchant_staff" ||
          identity.user_type == "merchant"
        ) {
          self.showDiv = true;
        } else {
          self.showDiv = false;
        }
        if (identity.user_type == "merchant_staff") {
          self.myname = identity.merchant_staff_name;
        } else {
          self.myname = userInfo.login_name;
        }
        //基本信息显示隐藏
        if(userInfo.agentType==1||userInfo.agentType==2){
          self.baseInfo=false
        }else{
          self.baseInfo=true
        }
      } else {
        alert("获取用户信息错误！!");
      }
    });
    // eventBus.$on("user_title", function(val) {
    //   self.user_title = val;
    // });
    // eventBus.$on("Jurisdiction", function(val) {
    //   if (val == true) {
    //     self.showDiv = true;
    //   } else {
    //     self.showDiv = false;
    //   }
    // });
    this.getComplaintCall()
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "navbarData"])
  },
  methods: {
    //获取投诉电话
    getComplaintCall() {
      agencyQnbarRequest('GetDutyStaff')
      .then(res => {
        this.complaintCall = res.data.contact_information
      })
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    handleOnLogout(rsp) {
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    },
    // 退出登录
    runLogout() {
      var postParams = {
        local_sess: PT.qnlogin.getLocalSess()
      };
      PT.apiClient.query(SvrApi.logout, postParams, this.handleOnLogout);
      PT.qnlogin.logout();

      this.hasLogin = PT.qnlogin.isLocalSessOk;
    },
    submitForm(formName) {
      var self = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          var data = {
            new_pwd: self.ruleForm2.pass,
            repeat_new_pwd: self.ruleForm2.checkPass
          };
          //老板
          if (self.identity.user_type == "merchant") {
            PT.apiClient.query(SvrApi.modifymyBoss, data, function(rsp) {
              if (rsp.code == 0) {
                self.$alert("密码修改成功", "提示");
                self.runLogout();
              } else {
                self.$alert(res.msg, "提示");
              }
            });
          } else if (self.identity.user_type == "merchant_staff") {
            //员工
            PT.apiClient.query(SvrApi.modifymyStaff, data, function(rsp) {
              if (rsp.code == 0) {
                self.$alert("密码修改成功", "提示");
                self.runLogout();
              } else {
                self.$alert(res.msg, "提示");
              }
            });
          }
        } else {
          alert("error submit!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changePSW() {
      var self = this;
      self.showDialog = true;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .errLog-container {
    display: inline-block;
    position: absolute;
    right: 150px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    width: 22px;
    height: 22px;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .nav-info {
    position: absolute;
    right: 140px;
    top: 0;
    font-size: 18px;
  }
}
@media screen and (min-width: 1515px) {
  .five_div {
    display: block;
  }
  .four_div {
    display: block;
  }
  .three_div {
    display: block;
  }
  .two_div {
    display: block;
  }
  .one_div {
    display: block;
  }
}
@media screen and (max-width: 1515px) {
  .five_div {
    display: none;
  }
  .four_div {
    display: none;
  }
  .three_div {
    display: block;
  }
  .two_div {
    display: block;
  }
  .one_div {
    display: block;
  }
}
@media screen and (max-width: 1200px) {
  .five_div {
    display: none;
  }
  .four_div {
    display: none;
  }
  .three_div {
    display: none;
  }
  .two_div {
    display: block;
  }
  .one_div {
    display: block;
  }
}
@media screen and (max-width: 825px) {
  .five_div {
    display: none;
  }
  .four_div {
    display: none;
  }
  .three_div {
    display: none;
  }
  .two_div {
    display: none;
  }
  .one_div {
    display: block;
  }
}
@media screen and (max-width: 685px) {
  .five_div {
    display: none;
  }
  .four_div {
    display: none;
  }
  .three_div {
    display: none;
  }
  .two_div {
    display: none;
  }
  .one_div {
    display: none;
  }
}
.headercontent {
  padding-left: 15px;
  line-height: 50px;
  min-height: 50px;
  font-size: 13px;
  background-color: #eef1f6;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/Navbar.vue?9a91bdca